module.exports = __webpack_public_path__ + "media/assets/images/flags/ug-3317eccb6ad63de3197287e3affd0471.svg";